import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yesNo'
})
export class YesNoPipe implements PipeTransform {
  transform(value: any, args?: any): string {

    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';

    } else if (typeof value === 'string') {
      return value === 'Y' ? 'Yes' : 'No';
    } else if (typeof value === 'number') {
      return value === 1 ? 'Yes' : 'No';
    } else {
      return null;
    }

  }
}
